import React from 'react';

// Who triggered a report, for the Sales histories: the signed-in user
// (pdp_audit_reports / consumer_voice_audits / prep_packs.user_id) or, for
// anonymous public-tool runs, the captured lead. The user wins when both
// are set (a signed-in run never captures a lead, but a claimed funnel
// account can re-attribute old lead rows).
export interface RequestedByUser {
  userid: number;
  email: string | null;
  firstName?: string | null;
  lastName?: string | null;
}

export function requestedByEmail(
  user: RequestedByUser | null | undefined,
  lead: { email: string } | null | undefined,
): string | null {
  return (user && user.email) || (lead && lead.email) || null;
}

export function RequestedByCell({
  user,
  lead,
}: {
  user?: RequestedByUser | null;
  lead?: { id?: number; email: string } | null;
}) {
  const email = requestedByEmail(user, lead);
  if (!email) return <span className="text-muted">—</span>;
  const name = user ? [user.firstName, user.lastName].filter(Boolean).join(' ').trim() : '';
  const title = user && user.email ? `Run by ${name || 'a signed-in user'}` : 'Run from the public tool (lead)';
  return (
    <span className="text-accent-text font-medium" title={title}>
      {email}
    </span>
  );
}
